// extracted by css-extract-rspack-plugin
export default {"wrapper":"_108e699d"};